import axios from "axios";
import { baseUrl } from "./helper";
import {
    getAdminToken,
    removeAdminToken,
} from "./localStorage";

const httpClient = axios.create({
    baseURL: baseUrl,
    timeout: 10000,
    headers: {
        "Content-Type": "application/json",
    },
});

// REQUEST INTERCEPTOR
httpClient.interceptors.request.use(
    (config) => {
        const token = getAdminToken();

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// RESPONSE INTERCEPTOR
httpClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            const status = error.response.status;

            if (status === 401) {
                // FULL CLEAN LOGOUT
                removeAdminToken();

                if (window.location.pathname !== "/login") {
                    window.location.href = "/login";
                }
            }

            if (status === 403) {
                console.error("Forbidden access");
            }

            if (status === 500) {
                console.error("Server error");
            }
        }

        return Promise.reject(error);
    }
);

export default httpClient;